import script from "./withDrawal.vue?vue&type=script&lang=ts&setup=true"
export * from "./withDrawal.vue?vue&type=script&lang=ts&setup=true"

import "./withDrawal.vue?vue&type=style&index=0&id=58603abf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58603abf"]])

export default __exports__